module.exports = __webpack_public_path__ + "img/mico-img.c8488122.jpg";